import { render, staticRenderFns } from "./ViewMember.vue?vue&type=template&id=c2fb5024&scoped=true"
import script from "./ViewMember.vue?vue&type=script&lang=js"
export * from "./ViewMember.vue?vue&type=script&lang=js"
import style0 from "./ViewMember.vue?vue&type=style&index=0&id=c2fb5024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fb5024",
  null
  
)

export default component.exports